
<div class="lm-border pa-3" v-if="data">
    <div class="v-flex step-title ">
        <div class=" primary--text" style="padding-top: 3px;">
            <span>{{ collective ? "Rechnungsposten für Anlage " + unit.fabricNo : "Rechnung" }}</span>
        </div>
        <p-inc-invoice-stamp-menu
            v-if="!collective"
            :data    = "data"
            :unit-id = data.unit.id
            @stamped = "onStamped"
            @mail    = "onSendStampMail"
            @reset   = "onReset"
            style="margin-bottom: 3px;"
        />
    </div>

    <!-- Invoice dates -->
    <p-inc-invoice-dates
        v-if="!collective"
        :data = "data"
        :collective = "false"

    />
    <!-- Invoice dates -->

    <!-- Invoice number and invoice date -->
    <v-row class="no-frame mt-0" v-if="!collective">
        <v-col class="no-frame mr-2">
            <v-text-field
                v-model        = "data.invoicenumber"
                :rules         = "[requiredOnTerminationRule]"
                :label         = "$t('invoice.invoicenumber')"
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
            />
        </v-col>
        <v-col class="no-frame ml-2">
            <f-date-picker
                v-model = "data.invoiceDate"
                label   = "invoice.invoiceDate"
                :time   = "false"
            />

        </v-col>
    </v-row>
    <!-- Invoice number and invoice date -->

    <slot name="required"></slot>
    <v-row
        v-if="showCosts"
        class = "no-frame mt-0"
    >
        <v-col
            class  = "no-frame col-6 pr-1 pl-0 primary--text"
            style="font-size: 12px; text-align: center"
        >
            Urspungsrechnung
        </v-col>
        <v-col
            class="no-frame col-6 pl-2 primary--text"
            style="font-size: 12px; text-align: center"
        >
            Korrigierte Rechnung
        </v-col>
    </v-row>

    <v-row
        class = "no-frame mt-0"
    >
        <v-col class = "no-frame col-6 pr-2">
            <p-inc-invoice-amount
                :class           = "showCosts ? 'lm-border pl-2 pr-2' : ''"
                :label           = "showCosts ? 'Betrag' : $t('invoice.cost.net')"
                :status          = "data.status"
                :item            = "data.item_1"
                :amount          = "data.item_1.amount"
                :calculation     = "calculation"
                :show-costs      = "showCosts"
                :form            = "form"
                :validate-amount = "validate"
            />
        </v-col>
        <v-col class="no-frame col-6 pl-2">
            <p-inc-invoice-amount
                v-if             = "!bid"
                :class           = "showCosts ? 'lm-border pl-2 pr-2' : ''"
                :label           = "showCosts ? 'Betrag' : $t('invoice.cost.correction')"
                :status          = "data.status"
                :item            = "data.item_1"
                :amount          = "data.item_1.correction"
                :show-costs      = "showCosts && !bid"
                :form            = "form"
                :accept-spacer   = "bid !== null"
                :validate-amount = "false"
            />
        </v-col>
    </v-row>
</div>
